var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaylistEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Playlist_Empty__Icn/40px/Playlist_Empty",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Playlist_Empty__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Playlist_Empty__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25,10 C26.1045695,10 27,10.8954305 27,12 L27,28 C27,29.1045695 26.1045695,30 25,30 L15,30 C13.8954305,30 13,29.1045695 13,28 L13,12 C13,10.8954305 13.8954305,10 15,10 L25,10 Z M25,12 L15,12 L15,28 L25,28 L25,12 Z M22.1213203,15.4644661 L23.5355339,16.8786797 L21.4144661,18.9994661 L23.5355339,21.1213203 L22.1213203,22.5355339 L19.9994661,20.4144661 L17.8786797,22.5355339 L16.4644661,21.1213203 L18.5854661,18.9994661 L16.4644661,16.8786797 L17.8786797,15.4644661 L19.9994661,17.5854661 L22.1213203,15.4644661 Z",
    id: ".._.._src_svg_Icn_40px_Playlist_Empty__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistEmpty);
export default __webpack_public_path__ + "static/media/Playlist_Empty.818ddcce9c1f16c2c8b2e0ffec47acbc.svg";
export { ForwardRef as ReactComponent };